<template>
	<div id="resetPasswordModal" class="modal" role="dialog" v-if="showing">
		<loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
		<div class="modal-backdrop" @click="$emit('close')"></div>
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<div>
						<h3 class="uptext">Reset Password</h3>
					</div>
				</div>
				<div class="modal-body">
					<div class="formContent tableView">
						<div class="tableSection sectionCredentials">
							<!-- <div class="block inputCell email isFocused">
                <div class="title">Email</div>
                <div class="input placeholder">
                  <input
                    v-model="email"
                    type="email"
                    placeholder="name@domain.com"
                    class="form-control"
                  />
                </div>
              </div> -->
							<div class="block inputCell isFocused">
								<div class="title">Old Password</div>
								<div class="input placeholder">
									<input
										v-model="oldPassword"
										type="password"
										placeholder="Old Password"
										class="form-control"
										v-on:keyup.enter="resetPassword"
									/>
								</div>
							</div>
							<a href="" class="footer"
								>Enter the old password you used when signing up.
							</a>
							<!-- <a href="" class="footer"
                >Enter the email you used when signing up and we’ll send you a
                link to reset your password.
              </a> -->
						</div>

						<!-- <div class="button buttonLarge" :class="[!(email) ? 'buttonDisabled':'buttonTint']">
                  <div class="title" @click="resetPassword">Send Password Reset Email</div>
                </div> -->
					</div>
				</div>
				<div class="modal-footer">
					<div>
						<b-button
							class="btn-default btn-cancel"
							@click="$emit('update:showing', false)"
							>Cancel</b-button
						>
						<b-button
							class="btn-submit"
							:disabled="!oldPassword"
							type="submit"
							@click="resetPassword"
							>Next</b-button
						>
					</div>
				</div>
			</div>
		</div>
		<ChangePassword
			v-if="isChangePassword"
			id="changepasswordModal"
			:oldPassword="oldPassword"
			:isChangePassword="isChangePassword"
			:showing="showing"
			@close="
				isChangePassword = false;
				$emit('close');
			"
		></ChangePassword>
	</div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { getUserEmail } from "../utils/auth";
import Auth from "@aws-amplify/auth";
import Amplify from "@aws-amplify/core";
import ChangePassword from "./ChangePassword";

export default {
	name: "ResetPassword",
	props: ["showing"],
	data() {
		return {
			oldPassword: null,
			email: getUserEmail(),
			isLoading: false,
			fullPage: true,
			dismissSecs: 5,
			dismissCountDown: 0,
			err: "",
			isChangePassword: false
		};
	},
	components: {
		Loading,
		ChangePassword
	},
	mounted() {},
	methods: {
		countDownChanged(dismissCountDown) {
			this.dismissCountDown = dismissCountDown;
		},
		resetPassword() {
			this.isLoading = true;
			setTimeout(() => {
				this.isLoading = false;
				this.isChangePassword = true;
			}, 1000);
			// Auth.forgotPassword(this.email)
			//   .then((data) => {
			//     // console.log(data);
			//     this.isChangePassword = true;
			//     //this.$router.push({ name: 'reset' , query : {email : this.email}})
			//   })
			//   .catch((err) => {
			//     this.isLoading = false;
			//     console.log(err);
			//     this.err = err.message;
			//     this.dismissCountDown = this.dismissSecs;
			//   });
		}
	}
};
</script>
